import { doc, updateDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { BrandLanguage, UpdateBrandLanguage } from "../type";
import { LanguageDB } from "./Language";

export const updateBrandLanguage = async (
  brandId: string,
  languageId: string,
  language: UpdateBrandLanguage,
): Promise<BrandLanguage> => {
  const docRef = doc(db, `brands/${brandId}/languages/${languageId}`);

  await updateDoc(docRef, {
    ...language,
    updatedAt: serverTimestamp(),
  });

  const snapshot = await getDoc(docRef);

  return new LanguageDB(snapshot).toBrandLanguage();
};
